<template>
  <div>
    <el-row class="condition">
      <div>
        探测日期
        <el-date-picker style="width: 82%;"
          type="datetimerange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="timestamp"
          :picker-options="pickerOptions"
          v-model="time"
          @change="getDatas">
        </el-date-picker>
      </div>
      <div style="width:10%;">
        <el-select v-model="deviceType" @change="getDatas">
          <el-option label="全部" :value="''"></el-option>
          <el-option v-for="(device,index) in deviceTypeList"
            :key="index"
            :value="device.key">
          </el-option>
        </el-select>
      </div>
      <div style="width:10%;">
        <el-select v-model="netType" @change="getDatas">
          <el-option label="全部" :value="''"></el-option>
          <el-option label="有线" :value="0"></el-option>
          <el-option label="无线" :value="1"></el-option>
        </el-select>
      </div>
      <div style="width:10%;">
        <el-select v-model="netQuality" @change="getDatas">
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="合格" :value="0"></el-option>
          <el-option label="不合格" :value="1"></el-option>
        </el-select>
      </div>

      <div style="width:20%">
        <el-input v-model="searchKey" placeholder="关键字" @change="getDatas">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div>
      <el-button type="primary" plain @click="outportInfo"> 导出</el-button>

    </el-row>
    <el-table  border highlight-current-row
      row-key="guid"
      :header-cell-style="{background:'#a6aeb7',color:'#000'}"
      :data="listData"
      @current-change="changeRow"
      @selection-change="handleSelectionChange">
      <el-table-column type="expand" align="center">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <div v-for="(extentInfo, index) in props.row.extentInfos" :key="index">
              <el-form-item v-for="(value, key) in extentInfo" :key="key" :label="key">
                <span>{{value}}</span>
              </el-form-item>
            </div>
          </el-form>
        </template>
      </el-table-column>

      <el-table-column type="selection" width="50" align="center" reserve-selection>
      </el-table-column>
      <el-table-column align="center" label="姓名" prop="nickname"></el-table-column>
      <el-table-column align="center" label="帐号" prop="loginAccount"></el-table-column>
      <el-table-column align="center" label="视讯号" prop="uid"></el-table-column>
      <el-table-column align="center" label="设备类型" prop="device"></el-table-column>
      <el-table-column align="center" label="网络类型" prop="netType">
        <template slot-scope="scope">
          {{ scope.row.netType == 1 ? '无线' : '有线' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="国家及地区" prop="countryCode"></el-table-column>

      <el-table-column align="center" prop="upRelay">
        <template slot="header">
          <div>最优上行</div>
          <div>Relay</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="downRelay">
        <template slot="header">
          <div>最优下行</div>
          <div>Relay</div>
        </template>
      </el-table-column>

      <!-- <el-table-column align="center" label="项目名称" prop=""></el-table-column>
      <el-table-column align="center" label="IT联系人" prop=""></el-table-column>
      <el-table-column align="center" label="IT联系方式" prop=""></el-table-column>
      <el-table-column align="center" label="回放URL" prop=""></el-table-column> -->

      <el-table-column align="center" label="IP" prop="ip"></el-table-column>
      <el-table-column align="center" prop="aliyunCode">
        <template slot="header">
          <div>地域地址</div>
          <div>阿里提供</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="运营商" prop="isp"></el-table-column>

      <el-table-column align="center" label="探测时间" prop="detectTm" width="100px">
        <template slot-scope="scope">
          {{new Date(scope.row.detectTm).Format('yyyy-MM-dd hh:mm:ss')}}
        </template>
      </el-table-column>
      <el-table-column align="center" label="探测状态" prop="result">
        <template slot-scope="scope">
          <span :class="scope.row.result == 1 ? 'dangerInfo' : ''">{{scope.row.result == 0 ? '成功' : '失败' }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="网络状况" prop="isBadNetwork">
        <template slot-scope="scope">
          <span :class="scope.row.isBadNetwork == 1 ? 'dangerInfo' : ''">{{scope.row.isBadNetwork == 0 ? '合格' : '不合格' }}</span>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination class="fy" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="currentPage" :page-sizes="[10,20,30,40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
      :total="totalElement">
    </el-pagination>
  </div>
</template>
<script>
  import {
    Loading
  } from "element-ui";
  export default {
    name: 'EventList',
    data: vm => ({
      listData: [],
      searchKey: null, //搜索关键字
      deviceType: '设备类型',
      netType: '网络类型',
      netQuality: '网络状况',
      time: '',

      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      currentPage: 1,
      pageSize: 10,
      totalElement: 0,
      checkedRows: [],
      deviceTypeList: []
    }),
    computed: {
      condition() {
        let obj = {
          condition: this.searchKey ? this.searchKey : null,
          device: this.deviceType == '设备类型' ? '' : this.deviceType,
          netType: this.netType == '网络类型' ? '' : this.netType,
          isBadNetwork: this.netQuality == '网络状况' ? '' : this.netQuality,
          startTime: this.time ? this.time[0] : -1,
          endTime: this.time ? this.time[1] : -1,
          pageNo: this.currentPage,
          pageSize: this.pageSize
        }

        return obj
      },
      // 勾选的guid集合
      guids() {
        let ids = []
        if (this.checkedRows.length > 0) {
          this.checkedRows.forEach(row => {
            ids.push(row.guid)
          })
        }
        return ids
      },
    },
    created() {
      // 当前时间和当前时间往前推3小时
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 3);
      this.time = [new Date(start).getTime(), new Date(end).getTime()]
      this.getDatas()
      this.getDeviceType()
    },
    methods: {
      getDeviceType(){
        this.$axios
            .post(
              this.detectApiUrl +
              "unpackDetect/getDeviceType", {}
            )
            .then(({
              data: {
                msg,
                data,
                code
              }
            }) => {
              if (code == 0) {
                this.deviceTypeList = data
              } else {
                console.log(msg);
              }
            })
            .catch(error => {
              console.log(error);
            });
        },

      handleSelectionChange(val) {
        this.checkedRows = val
        // console.log(val)
      },
      // 导出
      outportInfo() {
        let args = this.guids
        if (args.length == this.totalElement || args.length == 0) {
          args = null
        } else {
          args = args.join(',')
        }
        let url = this.detectApiUrl + "unpackDetect/exportExcel/" + args
        console.log(url)
        window.location.href = url

      },
      changeRow(row) {
        this.$emit('clickRow', row)
      },
      // 探测事件列表
      getDatas() {
        let loading = Loading.service({
          fullscreen: true,
          text: "数据加载中..."
        });
        this.$axios
          .post(
            this.detectApiUrl +
            "unpackDetect/findAllOfEventByPageLike", this.condition
          )
          .then(({
            data: {
              msg,
              data,
              code
            }
          }) => {
            if (code == 20000) {
              this.listData = data.list;
              this.totalElement = data.totalSize
            } else {
              this.$message({
                showClose: true,
                message: msg,
                type: "error"
              });
              console.log(msg);
            }
            loading.close();
          })
          .catch(error => {
            loading.close();
            this.$message({
              showClose: true,
              message: "系统异常",
              type: "error"
            });
            console.log(error);
          });
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getDatas()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getDatas()
      },
    }
  }
</script>
<style scoped>
  .fy {
    text-align: right;
    margin-top: 30px;
  }

  .condition {
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
  }

  .dangerInfo {
    color: red;
  }

  .pickerWidth {
    width: 100% !important;
  }


</style>
